import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { ToastService } from "../../../_services/toast.service";
import { PlanningFilesService } from "../../../_services/planning-files.service";

declare var jQuery: any;

import "../../../../assets/semantic/semantic.min.js";
import { FormGroup, FormControl } from "@angular/forms";

@Component({
  selector: "client-planning-files-modal",
  templateUrl: "./client-planning-files-modal.component.html",
  styleUrls: ["./client-planning-files-modal.component.css"],
})

export class ClientPlanningFilesModalComponent implements OnInit {
  
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() updatePlanningFiles: EventEmitter<object> = new EventEmitter<object>();
  private planning_id: number;
  private user_id;
  private planningFileToUpload: File | null = null;
  private planning_files: Array<Object> | null = null;
  private addPlanningFileLoading: boolean = false;
  private deletePlanningFileLoadingID: Array<number> = [];

  planning_form = new FormGroup({
    planning_file: new FormControl(),
    planning_file_title: new FormControl(),
  });

  constructor(
    private toast: ToastService, 
    private planningFilesService: PlanningFilesService
  ) { }
  
  ngOnInit() {}
  
  handlePlanningFileInput(files: FileList) {
    this.planningFileToUpload = files.item(0);
  }

  // Get planning files
  getPlanningFiles(planning_id) {
    this.planningFilesService.getPlanningFiles(planning_id).subscribe(
      (response) => {
        //console.log("this.planningFilesService.getPlanningFiles response:", response);
        this.planning_files = response;
      },
      (error) => {
        console.log("this.planningFilesService.getPlanningFiles error:", error);
        this.toast.error(
          error.error && error.error.message 
            ? error.error.message 
            : `Une erreur est survenue lors de la récupération des documents du planning.`,
          false,
          "Récupération des documents"
        );
      }
    );
  }

  // Add planning file
  addPlanningFile(planning_id, data) {
    if (!this.planningFileToUpload) {
      this.toast.error("Veuillez sélectionner un fichier.", false, "Ajout d'un document"); return;
    }
    if (!data.planning_file_title || !data.planning_file_title.trim().length) {
      this.toast.error("Veuillez indiquer un titre.", false, "Ajout d'un document"); return;
    }

    var body = new FormData();
    body.append("planning_id", planning_id);
    body.append("planning_file_title", data.planning_file_title);
    body.append("file", this.planningFileToUpload);
    
    this.addPlanningFileLoading = true;

    this.planningFilesService.addPlanningFile(body).subscribe(
      (response) => {
        //console.log("this.planningFilesService.addPlanningFile response:", response);
        this.resetPlanningFileData();
        this.toast.success(`Le document '${data.planning_file_title}' a été ajouté avec succès'`, false, "Ajout d'un document");
        this.getPlanningFiles(planning_id); // Update planning files list
        this.addPlanningFileLoading = false;
        this.updatePlanningFiles.emit({ planning_file: response, isDeleted: false});
      },
      (error) => {
        console.log("this.planningFilesService.addPlanningFile error:", error);
        this.toast.error(
          error.error && error.error.message 
            ? error.error.message 
            : `Une erreur est survenue lors de l'ajout de votre document.`,
          false,
          "Ajout d'un document"
        );
        this.addPlanningFileLoading = false;
      }
    );
  }

  deletePlanningFile(planning_file) {
    if (confirm(`Êtes-vous sûr de vouloir supprimer le document '${planning_file.title}' ?`)) {
      this.deletePlanningFileLoadingID.push(planning_file.id);
      this.planningFilesService.deletePlanningFile(planning_file).subscribe(
        (response) => {
          //console.log("this.planningFilesService.deletePlanningFile response:", response);
          this.toast.success(`Le document '${planning_file.title}' a été supprimé avec succès'`, false, "Suppression d'un document");
          this.getPlanningFiles(this.planning_id); // Update planning files list
          this.deletePlanningFileLoadingID = this.deletePlanningFileLoadingID.filter(x => x != planning_file.id);
          this.updatePlanningFiles.emit({ planning_file: response, isDeleted: true});
        },
        (error) => {
          console.log("this.planningFilesService.deletePlanningFile error:", error);
          this.toast.error(
            error.error && error.error.message 
              ? error.error.message 
              : `Une erreur est survenue lors de la suppression du document '${planning_file.title}'.`,
            false,
            "Suppression d'un document"
          );
          this.deletePlanningFileLoadingID = this.deletePlanningFileLoadingID.filter(x =>  x != planning_file.id);
        }
      );
    }
  }

  openPlanningFile(planning_file) {
    const API_URI = this.planningFilesService.getApiURI();
    window.open(`${API_URI}/${planning_file.filename}`);
  }

  // Reset planningFile data/inputs
  resetPlanningFileData() {
    this.planningFileToUpload = null;
    this.planning_files = null;
    this.planning_form.get('planning_file').reset();
    this.planning_form.get('planning_file_title').reset();
  }

  // Open modal
  openModal(planning_id: number) {
    this.planning_id = planning_id;
    this.user_id = localStorage.getItem("current_user_id");
    this.resetPlanningFileData();
    this.getPlanningFiles(this.planning_id);
    jQuery('#planning_files_modal').modal('show', { centered: true });
  }

  // Close modal
  closeModal() {
    jQuery('#planning_files_modal').modal('hide');
  }
}


// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/client/client-planning-files-modal/client-planning-files-modal.component.ts